module.exports = __webpack_public_path__ + "static/media/Robyn van Rooyen.9ab704e0.jpg";